import { Edit, Delete } from '@mui/icons-material';
import { Button, ButtonGroup } from '@mui/material';
import { ReactNode, useMemo } from 'react';

export interface SelectableChipProps {
  label: string;
  selected: boolean;
  onSelect: (e: any) => void;
  disabled?: boolean;
  id?: string;
  size?: 'small' | 'medium' | 'large';
  action?: ReactNode;
  isEditable?: boolean;
  onEdit?: () => void;
  isDeletable?: boolean;
  onDelete?: () => void;
}

export function SelectableChip({
  label,
  selected,
  disabled,
  id,
  size,
  onSelect,
  action,
  isEditable,
  onEdit,
  isDeletable,
  onDelete,
}: SelectableChipProps) {
  const variant = useMemo(() => {
    if (selected) {
      return 'contained';
    }
    return 'outlined';
  }, [selected]);

  if ((isEditable && Boolean(onEdit)) || (isDeletable && Boolean(onDelete))) {
    return (
      <ButtonGroup variant={variant} size={size} disableElevation>
        <Button
          // noWrap={false}
          // size={size as any}
          size={size}
          variant={variant}
          onClick={(e) => onSelect(e)}
          disabled={disabled}
          className={'chip-' + id}
          id={id}
          sx={{ flex: 1, display: 'flex' }}
        >
          {label}
        </Button>
        {isEditable && Boolean(onEdit) && (
          <Button size={size} variant={variant} onClick={onEdit}>
            <Edit fontSize={size} />
          </Button>
        )}
        {isDeletable && Boolean(onDelete) && (
          <Button size={size} variant={variant} onClick={onDelete}>
            <Delete fontSize={size} />
          </Button>
        )}
      </ButtonGroup>
    );
  }

  return (
    <Button
      size={size}
      variant={variant}
      className={'rounded-pill border chip-' + id}
      onClick={(e) => onSelect(e)}
      disabled={disabled}
      disableElevation
      id={id}
    >
      {label}
    </Button>
  );
}
